import type { AccessControlProvider } from "@refinedev/core";
import { EVIDENCE_RESOURCE, canReviewEvidence } from "@/lib/evidence";

/**
 * Only one resource here is narrower than "an admin": the evidence holds, which
 * the server opens to reviewers on `SAFETY_REVIEWER_USER_IDS` alone. The sider
 * asks this for every menu item, so the Evidence entry exists only for a
 * reviewer; every other resource answers yes, exactly as before there was a
 * provider. Buttons do not ask — their routes are the server's to refuse.
 */
export const accessControlProvider: AccessControlProvider = {
  can: async ({ resource }) => {
    if (resource !== EVIDENCE_RESOURCE) {
      return { can: true };
    }
    const reviewer = await canReviewEvidence();
    return reviewer ? { can: true } : { can: false, reason: "Evidence review access required" };
  },
  options: {
    buttons: { enableAccessControl: false, hideIfUnauthorized: false },
  },
};
